import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Button, Modal, ModalBody } from 'reactstrap'
import notifications from '../../api/notifications/hooks'
import { notificationCodeConfig } from '../../api/notifications/types'
import { MODAL_TYPES } from '../../common/constants'
import { hideModal } from '../../store/modal'

interface ReadAllModalProps {
    isOpen: boolean
    readAllModal: {
        activeTab: string
    }
}

const ReadAllModal = (props: ReadAllModalProps) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const { isOpen, readAllModal } = props
    const { activeTab } = readAllModal

    const { mutate: toggleMarkAsRead } = notifications.ToggleMarkAsRead.useMutation()

    const handleClose = () => dispatch(hideModal({ modalType: MODAL_TYPES.READ_ALL_MODAL }))

    const handleConfirm = () => {
        const codes = notificationCodeConfig[activeTab]
        const notificationCodes = Array.isArray(codes) ? codes : [codes]

        toggleMarkAsRead({ all: true, notificationCodes })
        handleClose()
    }

    return (
        <Modal isOpen={isOpen} toggle={handleClose} centered>
            <ModalBody>{t('modal.readAll.message')}</ModalBody>
            <div className="d-flex gap-2 justify-content-end mt-4 mb-2">
                <Button type="button" color="success" className="btn-label" id="delete-record" onClick={handleConfirm}>
                    <i className="mdi mdi-check label-icon align-middle fs-16"></i>
                    {t('view.common.conclusion.yes')}
                </Button>
                <Button type="button" color="primary" className="btn-label" data-bs-dismiss="modal" onClick={handleClose}>
                    <i className="mdi mdi-close label-icon align-middle fs-16"></i>
                    {t('button.cancel')}
                </Button>
            </div>
        </Modal>
    )
}

export default ReadAllModal
